import { render, staticRenderFns } from "./DraggableListItem.vue?vue&type=template&id=15f9f7c0&scoped=true&"
import script from "./DraggableListItem.vue?vue&type=script&lang=js&"
export * from "./DraggableListItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListItem.vue?vue&type=style&index=0&id=15f9f7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f9f7c0",
  null
  
)

export default component.exports